import React from 'react';
import { useAtom } from 'jotai';
import styles from '../css/index.module.scss';
import PageTitle from '../../../components/PageTitle';
import MyButton from '../../../components/MyButton';
import MyInput from '../../../components/MyInput';
import { cancellationReasonsFiltersAtom } from '../../../atoms/cancellationReasonsAtoms';

function CancellationReasonsHeader({ onAddClick }) {
  const [filters, setFilters] = useAtom(cancellationReasonsFiltersAtom);

  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <div className={styles.headerLeftTop}>
          <PageTitle text="Причины отмены" />
        </div>
        <div className={styles.headerLeftBottom}>
          <MyInput
            value={filters.searchText}
            onChange={(ev) => setFilters({ searchText: ev.target.value || undefined, page: 1 })}
            placeholder="Поиск по названию"
            functionAtCleaning={() => setFilters({ searchText: '', page: 1, newDate: '' })}
          />
        </div>
      </div>
      <div className={styles.headerRight}>
        <div className={styles.headerRightBottom}>
          <MyButton text="Добавить" onClick={onAddClick} />
        </div>
      </div>
    </div>
  );
}

export default CancellationReasonsHeader;
